<div class="text-align-center">
  <sb-stamp class="mb-4" [shadow]="'default-sm'" [type]="'fill-white'">
    <sb-icon [name]="'mic-on-fill'" [size]="'3'">
      <div class="bg-gradient-blue mix-blend-mode-screen fill-parent"></div>
    </sb-icon>
  </sb-stamp>
  <h3 class="t-5@r color-jet mb-4">Microphone Access Required</h3>
  <div class="t-8@r color-charcoal mb-8 font-weight-500">
    Open the website / browser settings and make sure that the Microphone permissions are granted
  </div>
  <div class="t-8@r color-ash mb-6">
    To send voice messages, you must allow access to your microphone.
    @if (showCheckBrowser) {
      <br />
      {{ checkBrowserInfo }}
    }
  </div>
  <a
    class="width-full"
    sbButton
    [routerLink]="['/next/contact']"
    [size]="'big'"
    [variant]="'fill-void'"
    (click)="exit.emit()"
  >
    Need Help? Contact Us
  </a>
</div>
